import type { Theme } from "@mui/material";

export type TimeLineColor = "default" | "error" | "success" | "warning";
export type ColorMap = Map<TimeLineColor, (theme: Theme) => string>;

export const TIMELINE_COLORS = {
  default: "default",
  error: "error",
  success: "success",
  warning: "warning",
} as const;
